import { type MailboxInfo } from "owa-client-types";
import copilotSettingsStore from "../store/store";

export default function isCopilotStoreReady(mailboxInfo: MailboxInfo): boolean {
    const store = copilotSettingsStore(mailboxInfo);
    return store.isEnabled;
}
